<template>
<div class="main_panels">
<div class="col">
  <div class="panel personal_manager">
    <h4>Личный менеджер</h4>
    <div class="content" v-show="manager.fio != ''">
      <img :src="manager.image">
      <div class="info">
        <span class="name">{{manager.fio}}</span>
        <div class="contacts">
          <div class="contact">
            <span class="desc">Телефон:</span>
            <span class="value">{{manager.phone}}</span>
          </div>
          <div class="contact">
            <span class="desc">E-mail:</span>
            <span class="value">{{manager.email}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel payment" v-show="false">
    <h4>Счёт ждёт оплаты</h4>
    <div class="content">
      <div class="row">
        <span class="desc">Номер счёта:</span>
        <span class="value">№ 1293-234</span>
      </div>
      <div class="row">
        <span class="desc">Плательщик:</span>
        <span class="value">ИП «Название компании»</span>
      </div>
      <div class="row">
        <span class="desc">Дата создания:</span>
        <span class="value">24.02.2023</span>
      </div>
      <div class="row">
        <span class="desc">Стоимость:</span>
        <span class="value">63 990₽</span>
      </div>
    </div>
    <standart-button text="Оплатить онлайн"></standart-button>
  </div>
</div>
<div class="col">
  <div class="panel favorite">
    <h4>Избранное</h4>
    <div class="content">
      <div class="item" v-for="(item, index) in favorite" :key="index">
        <template v-if="item.image != null">
          <img :src="item.image" @click="navigate(item)" @error="error_load_img(item)">
        </template>
        <template v-if="item.image == null">
          <img :src="empty_image" @click="navigate(item)">
        </template>
        <p @click="navigate(item)">{{item.name}}</p>
        <div class="fav" :class="[{active : item.in_fav}]" @click="toggleFavorite(item)">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10.5165 17.3417C10.2332 17.4417 9.7665 17.4417 9.48317 17.3417C7.0665 16.5167 1.6665 13.075 1.6665 7.24166C1.6665 4.66666 3.7415 2.58333 6.29984 2.58333C7.8165 2.58333 9.15817 3.31666 9.99984 4.45C10.8415 3.31666 12.1915 2.58333 13.6998 2.58333C16.2582 2.58333 18.3332 4.66666 18.3332 7.24166C18.3332 13.075 12.9332 16.5167 10.5165 17.3417Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
    <standart-button @click="function(){$router.push({ name: 'favorite' })}" text="Перейти в избранное"></standart-button>
  </div>
</div>
<div class="col">
  <div class="panel basket">
    <h4>Моя корзина</h4>
    <div class="content">
      <div class="item" v-for="(item, index) in basket" :key="index">
        <template v-if="item.image != null">
          <img v-if="!item.deleted" :src="item.image" @click="navigate(item)" @error="error_load_img(item)">
        </template>
        <template v-if="item.image == null">
          <img v-if="!item.deleted" :src="empty_image" @click="navigate(item)">
        </template>
        <div class="mid">
          <p class="title" @click="navigate(item)">{{item.name}}</p>
          <p class="price">
            <template v-if="item.b_custom_price">
              <span class="curr">{{item.price}}</span>
              <span class="old">{{item.custom_price}}</span>
            </template>
            <template v-if="!item.b_custom_price">
              <span class="curr">{{item.price}}</span>
            </template>
          </p>
          <standart-button v-if="item.deleted" @click="returnProduct(item)" text="Вернуть товар"></standart-button>
        </div>
        <basket-button v-if="!item.deleted" @click="removeFromBasket(item)"></basket-button>
      </div>
    </div>
    <standart-button text="Перейти в корзину" @click="function(){$router.push({ name: 'basket' })}"></standart-button>
  </div>
</div>
</div>
</template>

<script>
import StandartButton from '@/components/share/StandartButton.vue';
import BasketButton from "@/components/share/BasketButton";
import axios from "axios";

export default {
  name: 'MainTab',
  components: {
    StandartButton,
    BasketButton,
  },
  data() {
    return{
      empty_image : require('@/assets/catalog/product/empty.svg'),

      manager: {
        image: require('@/assets/empty.svg'),
      },


      favorite : [],

      basket : []
    }
  },
  methods : {
    error_load_img: async function(product) {
      product.image = this.empty_image;
    },
    loadData: async function() {
      let res = await axios.get(window.api_url + "main/main");
      this.manager = res.data.data.manager;

      this.favorite = res.data.data.favorite.list;

      this.basket = res.data.data.basket.list;
    },
    navigate : function(product) {
      this.$router.push(
          {
            name:'catalog_product',
            params: {
              product: product.product_id,
              section: product.section_code
            }
          }
      )
    },
    toggleFavorite : async function(product) {
      if(!product.in_fav) {
        await axios.get(window.api_url + "favorite/add?id="+product.id);
        product.in_fav = true;
      }
      else {
        await axios.get(window.api_url + "favorite/remove?id="+product.id);
        product.in_fav = false;
      }
    },
    removeFromBasket : async function(product) {
      await axios.get(window.api_url + "basket/set?id="+product.product_id);
      product.deleted = true;
      this.$emit("basket_changed");
    },
    returnProduct : async function(product) {
      let qnt = product.quantity;
      await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt);
      product.deleted = false;
      this.$emit("basket_changed");
    }
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>
/*Panels*/
.main_panels {
  display: flex;
  gap: 20px;
}

.main_panels .col {
  flex: 1;
}

.main_panels .panel {
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
}

.main_panels .panel.personal_manager {
  margin-bottom: 20px;
}

.main_panels .panel h4 {
  margin: 0px 0px 20px 0px;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}



/*Panel Personal Manager*/
.main_panels .personal_manager .content {
  display: flex;
  gap: 16px;
}

.main_panels .personal_manager .content img {
  width: 104px;
  height: 104px;
}

.main_panels .personal_manager .content .info {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.main_panels .personal_manager .content .info .name{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}

.main_panels .personal_manager .content .info .contacts{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.main_panels .personal_manager .content .info .contact{
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.main_panels .personal_manager .content .info .contact .desc{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.main_panels .personal_manager .content .info .contact .value{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}



/*Panel Payment*/
.main_panels .payment .content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 26px;
}

.main_panels .payment .content .row{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main_panels .payment .content .desc{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.main_panels .payment .content .value{
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}



/*Panel Favorite*/
.main_panels .favorite .content {
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin: 0px -20px 26px -20px;
  height: 365px;
}

.main_panels .favorite .content .item{
  display: flex;
  align-items: center;
  padding: 16px 0px;
  margin: 0px 16px;
  border-bottom: 1px solid var(--Border, #EDEDED);
  justify-content: space-between;
  gap: 12px;
}

.main_panels .favorite .content .item img{
  width: 74px;
  height: 74px;
  cursor: pointer;
  border: 1px solid var(--Border, #EDEDED);
  border-radius: 8px;
}

.main_panels .favorite .content .item p{
  color: var(--Black, #222);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -moz-box;
  -moz-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  box-orient: vertical;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 134%;
  margin: 0;
  flex: 1;
  cursor: pointer;
}

.main_panels .favorite .content .fav {
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: start;
}

.main_panels .favorite .content .fav.active svg path{
  fill: var(--Blue);
}



/*Panel Basket*/
.main_panels .basket .content {
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin: 0px -20px 26px -20px;
  height: 365px;
}

.main_panels .basket .content .item{
  display: flex;
  padding: 16px 0px;
  margin: 0px 16px;
  border-bottom: 1px solid var(--Border, #EDEDED);
  justify-content: space-between;
  gap: 12px;
}

.main_panels .basket .content .item img{
  width: 74px;
  height: 74px;
  cursor: pointer;
  border: 1px solid var(--Border, #EDEDED);
  border-radius: 8px;
}

.main_panels .basket .content .item .mid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: 16px;
}

.main_panels .basket .content .item .mid .title{
  cursor: pointer;
}

.main_panels .basket .content .item .mid .price{
  display: flex;
  align-items: center;
  gap: 8px;
}

.main_panels .basket .content .item .mid .price .curr{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.main_panels .basket .content .item .mid .price .old{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-decoration: line-through;
}

.main_panels .basket .content .item p{
  color: var(--Black, #222);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -moz-box;
  -moz-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  box-orient: vertical;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 134%;
  margin: 0;
}

.main_panels .basket .content .basket_button{
  display: flex;
  align-self: start;
}



.main_panels .favorite .content::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.main_panels .favorite .content::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.main_panels .favorite .content::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}



.main_panels .basket .content::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.main_panels .basket .content::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.main_panels .basket .content::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .main_panels {
    flex-direction: column;
  }
}
</style>